import { render, staticRenderFns } from "./autologout.vue?vue&type=template&id=27bba815&"
import script from "./autologout.vue?vue&type=script&lang=js&"
export * from "./autologout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports